import Home from './Home'
import Login from './Login'
import ReconAIDataQuality from './ReconAIDataQuality'

export * from './store'

export default [ReconAIDataQuality, Home, Login]
